import { CLASSES } from '@/scripts/helpers/constants';

export default () => {
  const mails = [
    'gmail.com',
    'yahoo.com',
    'aol.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'facebook.com',
    'me.com',
    'mac.com',
    'live.com',
    'comcast.com',
    'googlemail.com',
    'google.com',
    'msn.com',
    'hotmail.co.uk',
    'yahoo.co.uk',
    'verizon.net',
    'att.net',
    'gmz.com',
    'mail.com'
  ];

  const KEYS = {
    SPACE: 32,
    ARROWDOWN: 40,
    ARROWUP: 38,
    ENTER: 13
  };

  const input = document.querySelectorAll('.email-suggestions-input');
  const suggestionsList = document.querySelectorAll('.email-suggestions-list');

  const removeElements = () => {
    const items = document.querySelectorAll('.email-suggestions-list__item');
    items.forEach(item => {
      item.remove();
    });

    suggestionsList.forEach(list => {
      list.classList.remove(CLASSES.IS_VISIBLE);
      list.classList.add(CLASSES.IS_HIDDEN);
    });
  };

  for (let i = 0; i < input.length; i++) {
    const displayNames = value => {
      input[i].value = value;
      removeElements();
    };

    input[i].addEventListener('keyup', e => {
      const positionItemBottom =
        window.innerHeight -
        (input[i].getBoundingClientRect().top + input[i].offsetHeight);

      removeElements();

      for (let mail of mails) {
        if (
          mail.startsWith(input[i].value.split('@')[1]) &&
          input[i].value !== '' &&
          input[i].value[0] !== '@'
        ) {
          const listItem = document.createElement('li');
          listItem.setAttribute('tabindex', mails.indexOf(mail) + 1);

          listItem.classList.add('email-suggestions-list__item');
          listItem.addEventListener('click', e => {
            displayNames(input[i].value.split('@')[0] + '@' + mail);
          });
          listItem.addEventListener('keypress', e => {
            if (e.keyCode === KEYS.ENTER) {
              displayNames(input[i].value.split('@')[0] + '@' + mail);
            }
          });
          let word = `${input[i].value.split('@')[0]}@${mail.substr(
            0,
            input[i].value.length
          )}`;
          word += mail.substr(input[i].value.length);
          listItem.innerHTML = word;

          const getListItems = Array.from(
            input[i].parentElement.children
          ).filter(chapter =>
            chapter.classList.contains('email-suggestions-list')
          );

          getListItems[0].appendChild(listItem);
          getListItems[0].classList.add(CLASSES.IS_VISIBLE);
          getListItems[0].classList.remove(CLASSES.IS_HIDDEN);

          if (positionItemBottom < 186) {
            getListItems[0].style.bottom = `${input[i].offsetHeight}px`;
            getListItems[0].style.top = 'auto';
            getListItems[0].classList.add('email-suggestions-list--top');
          } else {
            getListItems[0].style.top = `${input[i].offsetHeight}px`;
            getListItems[0].style.bottom = 'auto';
            getListItems[0].classList.remove('email-suggestions-list--top');
          }
        }
      }
      if (e.keyCode === KEYS.ARROWDOWN) {
        document.querySelectorAll('.email-suggestions-list li').forEach(listItem => {
          listItem.addEventListener('focus', function() {
            this.classList.add(CLASSES.IS_ACTIVE);
            const parentList = this.closest('.email-suggestions-list');
            if (parentList) {
              parentList.classList.remove(CLASSES.IS_ACTIVE);
            }
          });
          listItem.addEventListener('keydown', function(e) {
            if (e.keyCode === KEYS.ARROWDOWN) {
              const nextSibling = this.nextElementSibling;
              if (nextSibling) {
                nextSibling.focus();
                input[i].value = nextSibling.innerText;
              }
              return false;
            } else if (e.keyCode === KEYS.ARROWUP) {
              const previousSibling = this.previousElementSibling;
              if (previousSibling) {
                previousSibling.focus();
                input[i].value = previousSibling.innerText;
              }
              return false;
            }
          });
        });
        const firstListItem = document.querySelector('.email-suggestions-list li');
        if (firstListItem) {
          firstListItem.focus();
        }
      }
    });
  }
};
